module.exports = __webpack_public_path__ + "static/media/DSC00061.bba03962.jpg";